import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { PulseLoader } from 'react-spinners';

export default class Loader extends Component {
    constructor() {
        super();

        this.state = { loaderVisible: false, labels: [] };

        this.css = {
            display: 'block',
            margin: '0 auto',
            borderColor: '#CC0033',
        };

        this.loaderTasks = new Map();
    }

    startTask(taskConfig = null) {
        const taskUUID = uuidv4();
        this.loaderTasks.set(taskUUID, taskConfig);
        this.refreshLoaderVisibility();
        return taskUUID;
    }

    endTask(taskUUID) {
        if (typeof taskUUID === 'string' && taskUUID.length > 0) {
            if (this.loaderTasks.has(taskUUID)) {
                // wait a little to avoid blinking loader when doing multiple tasks sequentially
                setTimeout(() => {
                    this.loaderTasks.delete(taskUUID);
                    this.refreshLoaderVisibility();
                }, 500);

                return true;
            } else {
                return false;
            }
        } else {
            console.error('incorrect parameters');
            return false;
        }
    }

    refreshLoaderVisibility() {
        if (this.loaderTasks.size > 0) {
            const labels = [];
            this.loaderTasks.forEach((config, uuid) => {
                if (
                    typeof config === 'object' &&
                    config !== null &&
                    typeof config.label === 'string' &&
                    config.label.length > 0
                ) {
                    labels.push(config.label);
                }
            });

            const newState = { loaderVisible: true, labels };

            this.setState(newState);
            return true;
        } else {
            this.setState({ loaderVisible: false });
            return false;
        }
    }

    render() {
        if (this.state.loaderVisible) {
            return (
                <div className="eds_loader_container">
                    <div className="eds_loader">
                        {/* https://www.davidhu.io/react-spinners/ */}

                        <PulseLoader
                            color="rgb(206,38,56)"
                            loading={this.state.loaderVisible}
                            cssOverride={this.css}
                            size={20}
                        />
                        {this.renderPendingLabels()}
                    </div>
                </div>
            );
        } else {
            return <></>;
        }
    }

    renderPendingLabels() {
        return (
            <>
                {this.state.labels.map((label) => {
                    return <div className="eds_loader_label">{label}</div>;
                })}
            </>
        );
    }
}
